import React from "react";
import "./Loading.css";

const Loading = () => (
  <div>
    <div className="loader">
      <div className="ade"></div>
    </div>
  </div>
);

export default Loading;
